<template>
  <v-container fluid class="team-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-team`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Team
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-members`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Members
          </v-tab>
          <v-tab-item
            :value="'tab-team'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Team</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTeam($event, 'teamcode')"
                        v-bind:value="initvalue.teamcode"
                        placeholder="Team Code"
                        persistent-hint
                        single-line hint="Enter the team code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTeam($event, 'teamname')"
                        v-bind:value="initvalue.teamname"
                        placeholder="Team Name"
                        persistent-hint
                        single-line hint="Enter the team name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=teamtype
                        :value="initvalue.teamtype"
                        outlined
                        dense
                        v-on:change="onChangeTeam($event, 'teamtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the team type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeTeam($event, 'teamstatus')"
                          v-bind:label="initvalue.teamstatus"
                          v-model="initvalue.teamstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTeamRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-members'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Team Members</p>
                      </v-col>
                      <v-col md="1" align="right">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddMember = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="memberrank"
                        :headers="member_headers"
                        :items="teammembers"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteMember" width="500">
                            <v-card>
                              <v-card-title> Delete this Member? </v-card-title>
                              <v-card-text>
                                {{ delete_member.membername }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteMember = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTeamMember(delete_member)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.memberimage="{ item }">
                          <v-avatar v-if="item.memberimage!=null" size="40">
                            <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                          </v-avatar>
                          <v-avatar
                            v-else
                            color="warning"
                            size="40">
                            <p class="two-line"><span class="white--text headline">{{ item.membername[0].toUpperCase() }}</span></p>
                          </v-avatar>
                        </template>
                        <template v-slot:item.groupid="{ item }">
                          <p class="two-line" v-if="item.groupid!=undefined">{{ teamgroups.length>0 && teamgroups.find(group=>group._id == item.groupid) ? teamgroups.find(group=>group._id == item.groupid)['groupname'] || '' : ''  }}</p>
                        </template>
                        <template v-slot:item.subgroupid="{ item }">
                          <p class="two-line" v-if="item.subgroupid!=undefined">{{ teamsubgroups.length>0 ? teamsubgroups.find(subgroup=>subgroup._id == item.subgroupid)['subgroupname'] : ''  }}</p>
                        </template>
                        <template v-slot:item.membername="{ item }">
                          <p class="two-line"><strong>{{ item.membername }}</strong></p>
                          <p class="two-line">{{ item.membercode  }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTeamMemberDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTeamMemberDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/team/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddMember"
      persistent
      width="500px"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  class="mb-4"
                  :items="users.filter(user=>user.userstatus=='Active').map(x => {
                    return {text: x.username, value: x._id};
                  })"
                  v-on:change="selectUser"
                  v-model="add_member.userid"
                  v-bind:error="errorindex == 3"
                  placeholder="User"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch
                  color="primary"
                  v-bind:label="add_member.isLead==true ? 'On': ''"
                  v-model="add_member.isLead"
                  :value="true"
                  :false-value="false"
                  hint="Team Lead"
                  persistent-hint
                ></v-switch>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="add_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddMember=false; add_member={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTeamMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditMember"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberrank')"
                  :value="edit_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <!-- <v-select
                  class="mb-4"
                  :items="teamgroups.map(x => {return {text: x.groupcode, value: x._id};})"
                  v-on:change="onChangeMember($event, 'groupid')"
                  :value="edit_member.groupid"
                  placeholder="Group"
                  dense
                >
                </v-select> -->
              </v-col>
              <v-col cols="12" md="5">
                <!-- <v-select
                  class="mb-4"
                  :items="teamsubgroups.map(x => {
                    return {text: x.subgroupcode, value: x._id};
                  })"
                  v-on:change="onChangeMember($event, 'subgroupid')"
                  :value="edit_member.subgroupid"
                  placeholder="Subgroup"
                  dense
                >
                </v-select> -->
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membername')"
                  :value="edit_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membercode')"
                  :value="edit_member.membercode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membericon')"
                  :value="edit_member.membericon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberlink')"
                  :value="edit_member.memberlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberaction')"
                  :value="edit_member.memberaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditMember=false; edit_member={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editTeamMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      groupHeaders: [
        { text: "#", value: "grouprank", width: "10px" },
        { text: "Class", value: "groupclass" },
        { text: "Type", value: "grouptype" },
        { text: "Name & Code", value: "groupname" },
        { text: "Link & Action", value: "grouplink" },
        { text: "Icon", value: "groupicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      subgroupHeaders: [
        { text: "#", value: "subgrouprank", width: "10px" },
        { text: "Group", value: "groupid" },
        { text: "Name & Code", value: "subgroupname" },
        { text: "Icon", value: "subgroupicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      member_headers: [
        { text: "#", value: "memberrank", width: "10px" },
        { text: "Image", value: "memberimage", width: "8%" },
        { text: "Name", value: "membername" },
        { text: "Team Lead", value: "isLead", width: "10%"  },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      team: {},
      teamgroups: [],
      teamsubgroups: [],
      teamchannels: [],
      teammembers: [],
      teamtype: ['Team', 'Other Team'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_group: {},
      add_subgroup: {},
      add_member: {},
      add_channel: {},
      edit_group: {},
      edit_subgroup: {},
      edit_member: {},
      edit_channel: {},
      change_team: {},
      change_group: {},
      change_subgroup: {},
      change_member: {},
      change_channel: {},
      delete_group: {},
      delete_subgroup: {},
      delete_member: {},
      delete_channel: {},
      isDeleteGroup: false,
      isDeleteSubgroup: false,
      isDeleteMember: false,
      isDeleteChannel: false,
      isAddGroup: false,
      isAddSubgroup: false,
      isAddMember: false,
      isAddChannel: false,
      isEditGroup: false,
      isEditSubgroup: false,
      isEditMember: false,
      isEditChannel: false,
    }
  },
  computed: {
    ...mapState('Team', ['isReceiving']),
    ...mapState('Employee', ['employees']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Team', 
    [ 'getTeamsRequest',
      'deleteTeamGroupRequest', 'deleteTeamSubgroupRequest', 'deleteTeamMemberRequest',
      'insertTeamGroupRequest', 'insertTeamSubgroupRequest', 'insertTeamMemberRequest',
      'updateTeamRequest','updateTeamGroupRequest','updateTeamSubgroupRequest','updateTeamMemberRequest' 
    ]),
    ...mapActions('Employee', [ 'getEmployeesRequest']),
    ...mapActions('User', [ 'getUsersRequest']),
    selectUser(item){
      let user = this.users.find(user=>user._id==item);
      this.add_member = Object.assign({}, this.add_member, {membername: user.username});
    },
    async addTeamGroupRequest() {
      this.isAddGroup = false;
      this.add_group.teamid = this.initvalue._id;
      let result = await this.insertTeamGroupRequest(this.add_group);
      this.teamgroups.push(result);
      this.add_group = {};
    },
    async addTeamSubgroupRequest() {
      this.isAddSubgroup = false;
      this.add_subgroup.teamid = this.initvalue._id;
      let result = await this.insertTeamSubgroupRequest(this.add_subgroup);
      this.teamsubgroups.push(result);
      this.add_subgroup = {};
    },
    async addTeamMemberRequest() {
      this.isAddMember = false;
      this.add_member.teamid = this.initvalue._id;
      let result = await this.insertTeamMemberRequest(this.add_member);
      this.teammembers.push(result);
      this.add_member = {};
    },
    async addTeamChannelRequest() {
      this.isAddChannel = false;
      this.add_channel.teamid = this.initvalue._id;
      let result = await this.insertTeamChannelRequest(this.add_channel);
      this.teamchannels.push(result);
      this.add_channel = {};
    },
    deleteTeamGroupDialog(item) {
      this.isDeleteGroup = true;
      this.delete_group = {
        _id: item._id,
        groupname: item.groupname,
      };
    },
    deleteTeamSubgroupDialog(item) {
      this.isDeleteSubgroup = true;
      this.delete_subgroup = {
        _id: item._id,
        subgroupname: item.subgroupname,
      };
    },
    deleteTeamMemberDialog(item) {
      this.isDeleteMember = true;
      this.delete_member = {
        _id: item._id,
        membername: item.membername,
      };
    },
    async deleteTeamMember(payload) {
      this.isDeleteMember = false;
      let response = await this.deleteTeamMemberRequest(payload);
      let index = this.teammembers.findIndex((trans) => trans._id == response._id);
      this.teammembers.splice(index, 1);
    },
    async deleteTeamChannel(payload) {
      this.isDeleteChannel = false;
      let response = await this.deleteTeamChannelRequest(payload);
      let index = this.teamchannels.findIndex((trans) => trans._id == response._id);
      this.teamchannels.splice(index, 1);
    },
    editTeamGroupDialog(item) {
      this.edit_group = Object.assign({}, item);
      this.change_group = {};
      this.isEditGroup = true;
    },
    editTeamSubgroupDialog(item) {
      this.edit_subgroup = Object.assign({}, item);
      this.change_subgroup = {};
      this.isEditSubgroup = true;
    },
    editTeamMemberDialog(item) {
      this.edit_member = Object.assign({}, item);
      this.change_member = {};
      this.isEditMember = true;
    },
    editTeamChannelDialog(item) {
      this.edit_channel = Object.assign({}, item);
      this.change_channel = {};
      this.isEditChannel = true;
    },
    async editTeamRequest() {
      this.change_team._id = this.initvalue._id;
      await this.updateTeamRequest(this.change_team);
      router.push('/team/list');
    },
    async editTeamGroupRequest() {
      this.isEditGroup = false;
      this.change_group.teamgroupid = this.edit_group._id;
      let response = await this.updateTeamGroupRequest(this.change_group);
      let index = this.teamgroups.findIndex((x) => x._id == response._id);
      this.teamgroups.splice(index, 1, response);
      this.edit_group = {};
    },
    async editTeamSubgroupRequest() {
      this.isEditSubgroup = false;
      this.change_subgroup.teamsubgroupid = this.edit_subgroup._id;
      let response = await this.updateTeamSubgroupRequest(this.change_subgroup);
      let index = this.teamsubgroups.findIndex((x) => x._id == response._id);
      this.teamsubgroups.splice(index, 1, response);
      this.edit_subgroup = {};
    },
    async editTeamMemberRequest() {
      this.isEditMember = false;
      this.change_member.teammemberid = this.edit_member._id;
      let response = await this.updateTeamMemberRequest(this.change_member);
      let index = this.teammembers.findIndex((x) => x._id == response._id);
      this.teammembers.splice(index, 1, response);
      this.edit_member = {};
    }, 
    async editTeamChannelRequest() {
      this.isEditChannel = false;
      this.change_channel.teammemberid = this.edit_channel._id;
      let response = await this.updateTeamChannelRequest(this.change_channel);
      let index = this.teamchannels.findIndex((x) => x._id == response._id);
      this.teamchannels.splice(index, 1, response);
      this.edit_channel = {};
    },    
    onChangeTeam(value, field){
      this.change_team[field] = value;
    },
    onChangeGroup(value, field){
      this.change_group[field] = value;
    },
    onChangeSubgroup(value, field){
      this.change_subgroup[field] = value;
    },
    onChangeMember(value, field){
      this.change_member[field] = value;
    },  
    onChangeChannel(value, field){
      this.change_channel[field] = value;
    },     
  },

  async created () {
    this.initvalue = this.$route.params;
    this.teammembers = this.initvalue.members;
    if(!this.initvalue._id) this.$router.push({ name: 'TeamList' });

    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
